@if (label) {
  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400"
         [ngClass]="{'text-gray-400': formArray.disabled, 'text-gray-700 dark:text-gray-400': !formArray.disabled}"
  >
    {{ label }} @if (formArray.hasValidator(Validators.required)) {
    <span class="text-red-600">*</span>
  }
  </label>
}

<div class="space-y-3">
  @if (static && formArray.controls.length === 0) {
    <!-- TVG-363: a read-only empty array still shows a box with a placeholder,
         consistent with every other read-only field, instead of disappearing
         until Edit is pressed. Purely visual — no control is added to the
         form, so nothing empty is saved. -->
    <input
      disabled
      type="{{ type }}"
      placeholder="{{ placeholder }}"
      class="
        dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400
        dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30
        disabled:border-gray-100 disabled:placeholder:text-gray-300 dark:disabled:border-gray-800 dark:disabled:placeholder:text-white/15
      "
    >
  }
  @for (control of formArray.controls; track control; let i = $index) {
    <div class="flex items-center gap-2">
      <div class="relative flex-grow">
        <input
          [formControl]="$any(control)"
          [name]="name + '_' + i"
          type="{{ type }}"
          placeholder="{{ placeholder }}"
          mask="{{ mask }}"
          thousandSeparator="{{ thousandSeparator }}"
          class="
            dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400
            focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30
            dark:focus:border-brand-800 focus:shadow-focus-ring disabled:border-gray-100 disabled:placeholder:text-gray-300 dark:disabled:border-gray-800 dark:disabled:placeholder:text-white/15
          "
        >
        @if (control.invalid && (control.dirty || control.touched)) {
          <span class="absolute top-1/2 right-3.5 -translate-y-1/2 text-error-500">
            <lucide-icon size="18" [name]="CircleAlert"></lucide-icon>
          </span>
        }
      </div>

      @if (canRemove(i)) {
        <button
          type="button"
          (click)="removeControl(i)"
          class="flex h-11 w-11 items-center justify-center rounded-lg border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800"
        >
          <lucide-icon [name]="Trash2" size="18"></lucide-icon>
        </button>
      }
    </div>

    @if (control.invalid && (control.dirty || control.touched)) {
      <p class="text-theme-xs text-error-500 mt-1.5">
        @for (errorKey of control.errors ? Object.keys(control.errors) : []; track errorKey) {
          @if (control.errors) {
            <div>{{ errorKey | errorMessage:control.errors[errorKey] }}</div>
          }
        }
      </p>
    }
  }

  @if (canAddMore()) {
    <button
      type="button"
      (click)="addControl()"
      class="flex h-10 items-center justify-center gap-1.5 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 dark:hover:bg-gray-800"
    >
      <lucide-icon [name]="Plus" size="16"></lucide-icon>
      <span>{{ addButtonText }}</span>
    </button>
  }
</div>

@if (formArray.invalid && (formArray.dirty || formArray.touched)) {
  <p class="text-theme-xs text-error-500 mt-1.5">
    @for (errorKey of formArray.errors ? Object.keys(formArray.errors) : []; track errorKey) {
      @if (formArray.errors) {
        <div>{{ errorKey | errorMessage:formArray.errors[errorKey] }}</div>
      }
    }
  </p>
}
